var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeplr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "90.8672534%",
    cy: "10.9586258%",
    fx: "90.8672534%",
    fy: "10.9586258%",
    r: "172.001111%",
    gradientTransform: "translate(0.908673,0.109586),rotate(140.172042),scale(1.000000,1.206725),translate(-0.908673,-0.109586)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F80F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A942B5",
    offset: "99.9656883%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "0%",
    cy: "2.14812083%",
    fx: "0%",
    fy: "2.14812083%",
    r: "159.107686%",
    gradientTransform: "translate(0.000000,0.021481),rotate(46.320810),scale(1.000000,1.047856),translate(-0.000000,-0.021481)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45F9DE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A942B5",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "100%",
    cy: "100%",
    fx: "100%",
    fy: "100%",
    r: "96.0436813%",
    gradientTransform: "translate(1.000000,1.000000),rotate(180.000000),scale(1.000000,0.514961),translate(-1.000000,-1.000000)",
    id: "radialGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E957C5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC43B6",
    stopOpacity: 0.0437004098,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A942B5",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "57.6518464%",
    gradientTransform: "translate(0.500000,0.500000),rotate(119.937813),scale(1.000000,1.499193),translate(-0.500000,-0.500000)",
    id: "radialGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.184877622,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101010",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.2375438%",
    y1: "58.966132%",
    x2: "0%",
    y2: "0%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.184877622,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#radialGradient-1)",
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fillOpacity: 0.57,
    fill: "url(#radialGradient-2)",
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fillOpacity: 0.68,
    fill: "url(#radialGradient-3)",
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fillOpacity: 0.08,
    fill: "url(#radialGradient-4)",
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fillOpacity: 0.03,
    fill: "url(#linearGradient-5)",
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    rx: 16
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "K",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "70.4 170 70.4 108 129 170 161.6 170 161.6 168.4 94.2 97.8 156.4 30.8 156.4 30 123.6 30 70.4 89.2 70.4 30 44 30 44 170"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeplr);
export default __webpack_public_path__ + "static/media/keplr.4549666666b90ae05080bf72be138697.svg";
export { ForwardRef as ReactComponent };